const rankingData = [
  { rank: 1, title: '暗夜追光', heat: '9.8', tag: '悬疑', update: '更新至第28集', desc: '年度烧脑悬疑大剧，豆瓣开分9.2，全程高能无尿点' },
  { rank: 2, title: '长安十二时辰', heat: '9.7', tag: '古装', update: '全集48集', desc: '雷佳音易烊千玺领衔，盛唐气象震撼呈现' },
  { rank: 3, title: '狂飙2026', heat: '9.6', tag: '刑侦', update: '更新至第35集', desc: '张译张颂文再度联手，扫黑风暴再升级' },
  { rank: 4, title: '与凤行', heat: '9.5', tag: '仙侠', update: '全集40集', desc: '赵丽颖林更新二搭，仙侠美学巅峰之作' },
  { rank: 5, title: '玫瑰的故事', heat: '9.4', tag: '都市', update: '更新至第22集', desc: '刘亦菲演绎都市女性成长史诗' },
  { rank: 6, title: '大奉打更人', heat: '9.3', tag: '奇幻', update: '更新至第18集', desc: '王鹤棣田曦薇主演，爆笑探案两不误' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-fire-line"></i>
            实时热度
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">本周热播榜</h2>
          <p className="mt-2 text-foreground-500 text-sm">每日根据全网热度与观看数据实时更新，追剧不迷路</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="group flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg font-black ${
                item.rank === 1 ? 'bg-primary-500 text-white' :
                item.rank === 2 ? 'bg-accent-500 text-white' :
                item.rank === 3 ? 'bg-secondary-500 text-white' :
                'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium bg-secondary-100 text-secondary-700">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{item.desc}</p>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-xs text-foreground-400">{item.update}</span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-accent-600">
                    <i className="ri-fire-line text-[10px]"></i>
                    {item.heat}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}